let PN_PUBLISH_KEY = null;
let PN_SUBSCRIBE_KEY = null;

if (process.env.REACT_APP_ENV === 'staging') {
  PN_PUBLISH_KEY = 'pub-c-7745a87b-1c0b-401e-9f3d-03f01c4255ea';
  PN_SUBSCRIBE_KEY = 'sub-c-6b44dcd6-f025-11e9-bdee-36080f78eb20';
} else if (process.env.NODE_ENV === 'production') {
  PN_PUBLISH_KEY = 'pub-c-327f970f-e945-4ce3-9c67-8bdfa426b542';
  PN_SUBSCRIBE_KEY = 'sub-c-c24f2672-a871-11e9-be52-a296df0d2dec';
} else {
  PN_PUBLISH_KEY = 'pub-c-7745a87b-1c0b-401e-9f3d-03f01c4255ea';
  PN_SUBSCRIBE_KEY = 'sub-c-6b44dcd6-f025-11e9-bdee-36080f78eb20';
}

export const PUBNUB_PUBLISH_KEY = PN_PUBLISH_KEY;
export const PUBNUB_SUBSCRIBE_KEY = PN_SUBSCRIBE_KEY;
